window.ScreenXS = 0;
window.ScreenSM = 0;
window.ScreenMD = 0;
window.ScreenLG = 0;
window.ScreenXL = 0;

(function ($) {
  setVh();

  window.registerBreakpoint = function (
    breakpoint,
    trueFunction,
    falseFunction
  ) {
    var $window = $(window);
    $window.resize(function () {
      if ($window.width() >= breakpoint + 1) {
        trueFunction();
      } else {
        falseFunction();
      }
    });
    $window.trigger("resize");
  };

  window.debounce = function (func, wait, immediate) {
    var timeout;
    return function () {
      var context = this,
        args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      }, wait);
      if (immediate && !timeout) func.apply(context, args);
    };
  };

  $.fn.isInViewport = function (offset) {
    var offset = offset || 300;
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop + offset < viewportBottom;
  };

  window.scrollToEl = function ($element, extraOffset, callback = null) {
    var $adminBar = $("#wpadminbar");
    var offset = parseInt($element.offset().top);
    if ($adminBar.length > 0) {
      offset -= $adminBar.height();
    }
    var scrollMargin = parseInt($element.css("scroll-margin-top"));
    if (scrollMargin !== undefined) {
      scrollMargin = parseInt(scrollMargin);
      if ($(window).width() < ScreenSM) {
        scrollMargin = scrollMargin - 20;
      }
      offset -= scrollMargin;
    }

    if (extraOffset) {
      offset -= extraOffset;
    }

    $("html, body")
      .stop()
      .animate(
        {
          scrollTop: offset,
        },
        1000
      )
      .promise()
      .done(function () {
        if (callback) {
          callback();
        }
      });
  };

  function setVh() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  }
})(jQuery);
